import axios from 'axios'
import { constants } from './constants'
import history from '@history'
import store from 'app/store/index'
import { showMessage } from 'app/store/fuse/messageSlice'
const client = axios.create({
  baseURL: constants.URLLOCAL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 30000,
})

// Request interceptor to add token dynamically to every request
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('client-token');
    if (token) {
      config.headers['token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      console.log('Auth Error 401 in client portal')
      localStorage.removeItem('client-token')
      // Redirect to login if not already there
      if (!window.location.pathname.includes('/customerportal/login')) {
        history.push('/customerportal/login');
      }
    }
    return Promise.reject(error);
  }
)

export default client
